<div rol="button" tabindex="0" [matTooltip]="toolTip" [matTooltipShowDelay]="toolTipDelay" class="d-flex justify-content-center align-items-center chip" 
    [class.selected]="selected == true && disabled == false"
    [class.disabled]="disabled == true && selected == false"
    [class.selected-disabled]="disabled == true && selected == true"
    [class.with-icon]="iconName!=null" [class.without-icon]="iconName==null"
    [class.with-close-icon]="hasClose || isSelect" [class.filled]="filledStyle" 
    [class.chip-cursor]="hasAction && disabled == false" 
    (keyup.enter)="emitAction(true)" [attr.aria-pressed]="selected"  (click)="emitAction(true)">

    <div #divRef class="d-flex justify-content-center align-items-center chip-wrapper" >
        <div class="d-flex align-items-center" *ngIf="iconName!=null" >
            <mat-icon *ngIf="customIcon ==false"  [class]="iconClass"  [class.eac-c1]="selected == false" style="transform: scale(0.8);">{{iconName}}</mat-icon>
            <mat-icon *ngIf="customIcon" [svgIcon]="iconName!"  [class]="iconClass"  [class.eac-c1]="selected == false" style="transform: scale(0.8);"></mat-icon>
        </div>
        <!-- <div [attr.aria-label]="label">{{aText}}</div>         -->
        
        <div [class.eac-c1]="selected == false" [attr.aria-label]="label" *ngIf="allwaysLabel &&  aText!=label">{{label}} {{aText}}</div>        
        <div [class.eac-c1]="selected == false" [attr.aria-label]="label" *ngIf="allwaysLabel &&  aText==label">{{aText}}</div>        
        <div [class.eac-c1]="selected == false" [attr.aria-label]="label" *ngIf="allwaysLabel==false" style="overflow: hidden; text-overflow: ellipsis;" [style.max-width]="selectedMaxWidth" >{{aText}}</div>        

        <button *ngIf="isSelect"  mat-icon-button class="d-flex align-items-center"
            style="width: 24px; height: 24px;">
            <mat-icon class="d-flex align-items-center " [class.eac-c1]="selected == false" style="width: 24px; height: 24px;" *ngIf="opened==true">
                arrow_drop_up
            </mat-icon>
            <mat-icon class="d-flex align-items-center" [class.eac-c1]="selected == false" style="width: 24px; height: 24px;" *ngIf="opened==false">
                arrow_drop_down
            </mat-icon>
        </button>
    </div>
    <div class="d-flex align-items-center chip-button" *ngIf="hasClose">
        <button mat-icon-button [disabled]="disabled" (click)="close.emit(true)" class="d-flex align-items-center"
            style="width: 24px; height: 24px;">
            <mat-icon  style="transform: scale(0.8);" [class.eac-c1]="selected == false">close</mat-icon>
        </button>
    </div>
</div>